export const DBConfig = {
	name: "FlagBag",
	version: 17, // Increment version to force DB rebuild/migration
	objectStoresMeta: [
		{
			store: "records",
			storeConfig: { keyPath: "id", autoIncrement: false }, // Changed to false to use stationId
			storeSchema: [],
		},
		{
			store: "offline",
			storeConfig: { keyPath: "id", autoIncrement: false }, // Use composite key: flagBagID_timestamp
			storeSchema: [
				{ name: "flagBagID", keypath: "flagBagID", options: { unique: false } }, // Index for querying by flagBagID
				{ name: "updatedAt", keypath: "updatedAt", options: { unique: false } }, // Index for sorting
			],
		},
		{
			store: "station",
			storeConfig: { keyPath: "id", autoIncrement: false }, // Changed to false to use stationId
			storeSchema: [],
		},
		{
			store: "flagbag",
			storeConfig: { keyPath: "id", autoIncrement: false }, // Changed to false to use flagBagId
			storeSchema: [{ name: "stationId", keypath: "stationId", options: { unique: false } }],
		},
		{
			store: "volunteer",
			storeConfig: { keyPath: "volunteerId", autoIncrement: false },
			storeSchema: [
				{ name: "eventId", keypath: "eventId", options: { unique: false } },
			],
		},
		{
			store: "flagbaglog",
			storeConfig: { keyPath: "id", autoIncrement: false }, // Use composite key: flagbagId_timestamp
			storeSchema: [
				{ name: "flagbagId", keypath: "flagbagId", options: { unique: false } }, // Index for querying by flagbagId
				{ name: "stationId", keypath: "stationId", options: { unique: false } }, // Index for querying by stationId
				{ name: "timestamp", keypath: "timestamp", options: { unique: false } }, // Index for sorting by timestamp
			],
		},
	],
};
